
import WDButton from './wd-button'

export default class WDToggleButton extends WDButton {

  constructor(cfg)
  {
    super(cfg).classList.add('wd-toggle-button');
    
    this.checked = false;   
    this.on('click',() => this.toggle() );
  };
  
  toggle()
  {
    if (this.icon.classList.contains('fa-check-square')) this.checked = false;
    else this.checked = true;

    this.trigger('toggle',this.checked);
  };
  
  get checked() { return this.icon.classList.contains('fa-check-square');};
  set checked(val)
  {
    if (val === true) 
    {
      this.icon = 'fa-regular fa-check-square';
      this.classList.add('is-checked');
    }
    else 
    {
      this.icon = 'fa-regular fa-square';
      this.classList.remove('is-checked');
    }
  };
  
};

customElements.define('wd-toggle-button',WDToggleButton);
